module.exports = __webpack_public_path__ + "media/images/1642-protestation-2d9af1a4fe82ed0d3411efdb73a7f954.jpg";